angular
  .module('tgaAdmin')
  .filter('unsafe', [
    '$sce',
    function ($sce) {
      return function (val) {
        return $sce.trustAsHtml(val);
      };
    },
  ])
  .filter('trustUrl', [
    '$sce',
    function ($sce) {
      return function (recordingUrl) {
        return $sce.trustAsResourceUrl(recordingUrl);
      };
    },
  ])
  .filter(
    'formatDuration',
    () =>
      function (input) {
        let minutes;
        let seconds;
        let result = '';

        const totalSeconds = input / 1000;
        const totalMinutes = totalSeconds / 60;
        const totalHours = totalMinutes / 60;

        seconds = Math.floor(totalSeconds) % 60;
        minutes = Math.floor(totalMinutes) % 60;
        const hours = Math.floor(totalHours) % 60;

        result += `${hours}:`;

        if (minutes.toString().length === 1) {
          minutes = `0${minutes}`;
        }

        result += `${minutes}:`;

        if (seconds.toString().length === 1) {
          seconds = `0${seconds}`;
        }

        result += seconds;

        return result;
      },
  )
  .filter('percentage', [
    '$filter',
    function ($filter) {
      return function (input, decimals) {
        return `${$filter('number')(input * 100, decimals)}%`;
      };
    },
  ])
  .filter('parseDate', [
    'tzService',
    function (tzService) {
      return tzService.parseDate;
    },
  ])
  .filter('parseUserDate', [
    'tzService',
    function (tzService) {
      return tzService.parseUserDate;
    },
  ])
  .filter('formatUserDate', [
    'tzService',
    function (tzService) {
      return tzService.formatUserDate;
    },
  ])
  .filter('parseFormatUserDate', [
    'tzService',
    function (tzService) {
      return tzService.parseFormatUserDate;
    },
  ])
  .filter('parseAPISubscriptionDate', [
    'tzService',
    function (tzService) {
      return tzService.parseAPISubscriptionDate;
    },
  ])
  .filter(
    'minutesFromNow',
    () =>
      function (date) {
        const diff = moment(date).diff(moment(), 'milliseconds');
        const duration = moment.duration(diff);
        return duration.asMinutes();
      },
  )
  .filter(
    'gameType',
    () =>
      function (input) {
        switch (input) {
          case 'jump':
            return 'Jump';
          case 'match':
            return 'Match';
          case 'scramble':
            return 'Scramble';
          case 'recall':
            return 'Recall';
          case 'trivia':
            return 'Trivia';
          case 'grid':
            return 'Sort-it';
          case 'scenarios':
            return 'Scenarios';
          case 'jeopardy':
            return 'Jeopardy!';
          case 'detective':
            return 'Detective';
          case 'flash':
            return 'Flash';
          case 'scorm':
            return 'SCORM';
          case 'xapi':
            return 'xAPI';
          case 'wof':
            return 'Wheel of Fortune';
          case 'noodle':
            return 'Noodle™';
          case 'category_quest':
            return 'Category Quest';
          default:
            return input;
        }
      },
  )
  .filter(
    'requiredFields',
    () =>
      function (input) {
        switch (input) {
          case 'first_name':
            return 'First Name';
          case 'last_name':
            return 'Last Name';
          case 'initials':
            return 'Initials';
          case 'email':
            return 'Email';
          case 'phone':
            return 'Phone Number';
          case 'employee_id':
            return 'Employee ID';
          case 'country':
            return 'Country';
          case 'organization':
            return 'Organization';
          case 'username':
            return 'Unique Username';
          default:
            return input;
        }
      },
  )
  .filter(
    'questionType',
    () =>
      function (input) {
        switch (input) {
          case 'multiple_choice':
            return 'Multiple Choice';
          case 'multiple_select':
            return 'Multi-Select';
          case 'image':
            return 'Image Match';
          case 'scramble_letter':
            return 'Letter Scramble';
          case 'scramble_sentence':
            return 'Sentence Scramble';
          case 'text_input':
            return 'Text Input';
          case 'grid':
            return 'Grid';
          case 'interstitial':
            return 'Interstitial';
          case 'poll':
            return 'Poll';
          case 'wof_regular':
            return 'Spin';
          case 'wof_tossup':
            return 'Toss Up';
          case 'wof_bonus':
            return 'Bonus';
          case 'noodle_puzzle':
            return 'Noodle Puzzle';
          default:
            return input;
        }
      },
  )
  .filter(
    'userType',
    () =>
      function (input) {
        switch (input) {
          case 'super_admin':
            return 'Super Admin';
          case 'admin':
            return 'Admin';
          case 'editor':
            return 'Creator';
          case 'user':
            return 'Viewer';
          case 'player':
            return 'Player';
          case 'team':
            return 'Team';
          case 'creator_admin':
            return 'Creator Admin';
          case 'viewer_admin':
            return 'Viewer Admin';
          case 'sales_admin':
            return 'Sales Admin';
          case 'support_admin':
            return 'Support Admin';
          default:
            return input;
        }
      },
  )
  .filter(
    'activityType',
    () =>
      function (input) {
        switch (input) {
          case 'game':
            return 'Game';
          case 'pdf':
            return 'PDF';
          case 'image':
            return 'Image';
          case 'video':
            return 'Video';
          case 'audio':
            return 'Audio';
          case 'link':
            return 'URL';
          case 'journey':
            return 'Journey';
          case 'mission':
            return 'Mission';
          default:
            return input;
        }
      },
  )
  .filter(
    'activitySubtype',
    () =>
      function (input) {
        switch (input) {
          case 'game':
            return 'Game';
          case 'jump':
            return 'Jump';
          case 'match':
            return 'Match';
          case 'scramble':
            return 'Scramble';
          case 'recall':
            return 'Recall';
          case 'trivia':
            return 'Trivia';
          case 'grid':
            return 'Sort-it';
          case 'scenarios':
            return 'Scenarios';
          case 'jeopardy':
            return 'Jeopardy!';
          case 'detective':
            return 'Detective';
          case 'flash':
            return 'Flash';
          case 'scorm':
            return 'SCORM';
          case 'xapi':
            return 'xAPI';
          case 'wof':
            return 'Wheel of Fortune';
          case 'pdf':
            return 'PDF';
          case 'image':
            return 'Image';
          case 'video':
            return 'Video';
          case 'audio':
            return 'Audio';
          case 'link':
            return 'URL';
          case 'journey':
            return 'Journey';
          case 'mission':
            return 'Mission';
          case 'noodle':
            return 'Noodle™';
          default:
            return input;
        }
      },
  )
  .filter(
    'courseItemType',
    () =>
      function (input) {
        switch (input) {
          case 'game':
            return 'Game';
          case 'pdf':
            return 'PDF';
          case 'image':
            return 'Image';
          case 'video':
            return 'Video';
          case 'audio':
            return 'Audio';
          case 'link':
            return 'URL';
          default:
            return input;
        }
      },
  )
  .filter(
    'customFieldType',
    () =>
      function (input) {
        switch (input) {
          case 'text':
            return 'Text Input';
          case 'dropdown':
            return 'Dropdown';
          default:
            return input;
        }
      },
  )
  .filter('questionText', [
    '$filter',
    function ($filter) {
      /**
       * Extracts a plain string from the question, based on type.
       */
      const htmlToPlaintext = $filter('htmlToPlaintext');
      return function questionTextFilter(question) {
        // Try to format unexpected inputs
        // (e.g. if question.text is passed in directly)
        if (!angular.isObject(question)) {
          return htmlToPlaintext(question);
        }

        // Wheel of Fortune questions use `question.meta.string` if possible.
        if (/^wof_/.test(question.question_type)) {
          const puzzleString = question?.meta?.string;
          if (puzzleString != null) {
            return puzzleString;
          }
        }

        // By default/fallback, questions use `question.text` stripped of HTML.
        return htmlToPlaintext(question.text);
      };
    },
  ])
  .filter('gamifyTerm', () => {
    const terms = {
      question: {
        detective: 'case',
        wof: 'puzzle',
        noodle: 'prompt',
        category_quest: 'puzzle',
      },
      questions: {
        detective: 'cases',
        wof: 'puzzles',
        noodle: 'prompts',
        category_quest: 'puzzles',
      },
    };
    /**
     * Looks for an alternate value for a given term based on game type.
     * Otherwise returns its input.
     */
    return function termLookupFilter(term, gameType = null) {
      return terms[term]?.[gameType] || term;
    };
  })
  .filter(
    'titleCase',
    () =>
      function (input) {
        input = input || '';
        return input.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
      },
  )
  .filter(
    'sumProperty',
    () =>
      function (data, key, key2) {
        if (angular.isUndefined(data) || angular.isUndefined(key)) {
          return 0;
        }

        let sum = 0;

        angular.forEach(data, (value) => {
          if (key2) {
            angular.forEach(value[key], (value2) => {
              sum += parseInt(value2[key2], 10);
            });
          } else {
            sum += parseInt(value[key], 10);
          }
        });

        return sum;
      },
  )
  .filter(
    'telephone',
    () =>
      function (input) {
        // global function from phoneformat.js
        // eslint-disable-next-line no-undef
        return formatLocal('US', input);
      },
  )
  .filter(
    'capitalize',
    () =>
      function (input) {
        return angular.isString(input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
      },
  )
  .filter(
    'getProperty',
    () =>
      function (arr, key, unique, nojoin) {
        if (angular.isUndefined(arr) || angular.isUndefined(key)) {
          return;
        }
        // filter arrays that have undefined values due to filter chaining
        const filteredArr = angular.isArray(arr) ? arr.filter((v) => angular.isDefined(v)) : [];

        let output = filteredArr.map((value) => value[key]);

        if (unique) {
          output = _.uniq(output);
        }

        if (nojoin) {
          // eslint-disable-next-line consistent-return
          return output;
        }
        // eslint-disable-next-line consistent-return
        return output.join(', ');
      },
  )
  .filter(
    'isEmpty',
    () =>
      function (obj) {
        // https://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object
        return Object.keys(obj).length === 0;
      },
  )
  .filter(
    'unique',
    () =>
      function (arr, field) {
        return _.uniqBy(arr, field);
      },
  )
  .filter('htmlToPlaintext', [
    '$sanitize',
    ($sanitize) =>
      function (text) {
        if (!text) return '';

        let sanitizedText = String(_.unescape($sanitize(text)))
          .replace(/(<\/p>)/gim, '</p> ')
          .replace(/<[^>]+>/gm, '')
          .replace(/&nbsp;/g, ' ');

        let parser = new DOMParser();
        return parser.parseFromString(sanitizedText, 'text/html').body.textContent;
      },
  ])
  .filter(
    'truncate',
    () =>
      function (text, length = 30, omission = '…') {
        return _.truncate(text, { length, omission });
      },
  )
  .filter(
    'floor',
    () =>
      function (value) {
        return Math.floor(value);
      },
  )
  .filter(
    'bannerStatus',
    () =>
      function (value) {
        switch (value) {
          case 'pending':
            return 'banner.status_types.pending';
          case 'expired':
            return 'banner.status_types.expired';
          case 'resolved':
            return 'banner.status_types.resolved';
          default:
            return 'common.active';
        }
      },
  );
